import { IOption } from 'components/Inputs/SelectComponent/types';
import { TempLangType } from 'types/common';

export const languagesOptions: IOption<TempLangType>[] = [
  { value: 'en', label: 'English' },
  { value: 'pl', label: 'Polski' },
  { value: 'sl', label: 'Slovenščina' },
];

// TODO tempopry using TempLangType, change to LangType when implemented
export const languages: TempLangType[] = ['en', 'pl', 'sl'];
// export const languages: LangType[] = ['en', 'pl', 'sl', 'de', 'uk'];
